const DIRECTION_ENUM = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
}

export default DIRECTION_ENUM
